import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "../../styles/layout/sidebar.scss";
import categoryIcon from "../../assets/images/categoryIcon.svg";
import SIDE_BAR_LINKS from "./SibebarLinks";
import { filteredNavBarLinkLists as initialNavBarLinkLists } from "../../utils/sideBarLinksNew";

function SideBar({ isSidebarExpanded, toggleSidebar }) {
  const login = useSelector((state) => state.jwtAuthreducer);
  const employeeSections = login?.user?.employee_sections || [];
  const [restrictedLinks, setRestrictedLinks] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isFranchiseEmployee] = useState(() =>
    Number(localStorage.getItem("is_franchise_employee"))
  );
  const [isSuperFranchise] = useState(() =>
    Number(localStorage.getItem("is_super_franchise"))
  );
  const [isSubFranchise] = useState(() =>
    Number(localStorage.getItem("sub_franchise"))
  );
  const hiddenCategories = ["Employees"];
  const roles = login?.user?.employee_roles || [];

  const isSuperAdmin = roles.some((data) => data?.role_name === "SUPER ADMIN");

  useEffect(() => {
    let links = [];
    if (
      roles?.length > 0 &&
      isSuperFranchise !== 1 &&
      isFranchiseEmployee !== 1 &&
      isSubFranchise !== 1
    ) {
      Object.entries(SIDE_BAR_LINKS).forEach(([category, categoryLinks]) => {
        if (
          roles.some((role) => role.role_name === category.replace("_", " "))
        ) {
          links = [...links, ...categoryLinks];
        }
      });
      if (isSuperAdmin) {
        links = [...links, "/machine-master", "/observation-host-code"];
      }

      setRestrictedLinks([...new Set(links)]);
    } else {
      if (isSuperFranchise === 1 && !restrictedLinks.includes("/franchise")) {
        setRestrictedLinks((prevLinks) => [
          ...prevLinks,
          "/panne-wise-bus-report",
          "/patient-report",
          "/patient-appointment-details",
          "/appointment-payment",
          "/patient",
          "/franchise",
          "/test-rate-list-excel",
          "/panel-master",
          "/commission-report",
          "/estimate",
          "/investigation-deliveryDays",
          "/online-payment-details",
          // "/received-payment",
          "/credit-transfer",
          "/package-copy-rate",
          "/franchise-advance-payment-list",
          "/franchise-panel-wise-bus-report",
          "/franchise-investigation-details",
        ]);
      } else if (isFranchiseEmployee === 1 && isSubFranchise === 1) {
        setRestrictedLinks((prevLinks) => [
          ...prevLinks,
          "/panne-wise-bus-report",
          // "/patient-wise-search-report",
          "/patient-appointment-details",
          "/appointment-payment",
          "/patient",
          "/online-payment-details",
          // "/received-payment",
          "/patient-report",
          // "/package-copy-rate"
          "/franchise-advance-payment-list",
          "/franchise-investigation-details",
        ]);
      } else if (isFranchiseEmployee === 1) {
        setRestrictedLinks((prevLinks) => [
          ...prevLinks,
          "/franchise-panel-wise-bus-report",
          "/panne-wise-bus-report",
          // "/patient-wise-search-report",
          "/patient-appointment-details",
          "/appointment-payment",
          "/patient",
          "/franchise",
          "/test-rate-list-excel",
          "/panel-master",
          "/commission-report",
          "/online-payment-details",
          // "/received-payment",
          "/patient-report",
          "/credit-transfer",
          "/package-copy-rate",
          "/franchise-advance-payment-list",
          "/franchise-investigation-details",
        ]);
      }
    }
  }, [
    login,
    isSuperAdmin,
    isSuperFranchise,
    isFranchiseEmployee,
    isSubFranchise,
  ]);

  const normalizeSectionName = (value) =>
    (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const sectionNameAliases = {
    "franchise onboarding application": "franchise onboarding",
    "patient appointment details": "patient appointment details",
    "investigation package booking statistics":
      "investigation/package booking statistics",
    "total onboarding data": "total onboarding data report",
  };

  const allowedSectionNames = new Set(
    employeeSections.map((section) =>
      normalizeSectionName(section?.section_name)
    )
  );
  const allowedSectionIds = new Set(
    employeeSections.map((section) => Number(section?.id)).filter(Boolean)
  );
  const useSectionAccess = allowedSectionNames.size > 0;

  const hasSectionAccess = (link) => {
    if (isSuperAdmin && link?.allowSuperAdmin) return true;
    if (!allowedSectionNames.size) return true;
    if (link?.sectionId && allowedSectionIds.has(Number(link.sectionId))) {
      return true;
    }
    const normalized = normalizeSectionName(link?.name);
    return (
      allowedSectionNames.has(normalized) ||
      allowedSectionNames.has(sectionNameAliases[normalized])
    );
  };

  const hasRoleAccess = (link) => {
    if (useSectionAccess) return true;
    if (
      roles?.length > 0 &&
      isSuperFranchise !== 1 &&
      isFranchiseEmployee !== 1 &&
      isSubFranchise !== 1
    ) {
      return isSuperAdmin ? true : restrictedLinks.includes(link.link);
    }
    if (isFranchiseEmployee === 1 || isSuperFranchise === 1 || isSubFranchise === 1) {
      return restrictedLinks.includes(link.link);
    }
    return true;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const toggleSidebar = () => {
  //   if (isMobile) {
  //     setIsSidebarExpanded((prev) => !prev);
  //   }
  // };

  const filteredNavBarLinkLists =
    roles?.length > 0 &&
    isSuperFranchise !== 1 &&
    isFranchiseEmployee !== 1 &&
    isSubFranchise !== 1
      ? initialNavBarLinkLists
          .map((category) => ({
            ...category,
            links: category.links.filter((link) =>
              hasRoleAccess(link) &&
              hasSectionAccess(link)
            ),
          }))
          .filter((category) => category.links.length > 0)
      : initialNavBarLinkLists
          .map((category) => ({
            ...category,
            links: category.links.filter((link) =>
              hasRoleAccess(link) &&
              hasSectionAccess(link)
            ),
          }))
          .filter((category) => {
            const shouldHide =
              isFranchiseEmployee === 1 ||
              isSuperFranchise === 1 ||
              isSubFranchise === 1;

            const hasEmployeeLink = category.links.some((link) =>
              link.link.includes("/employee")
            );

            if (shouldHide) {
              return !(
                hiddenCategories.includes(category.category) && !hasEmployeeLink
              );
            }

            return true;
          });

  return (
    <div
      className={` ${
        !isSidebarExpanded
          ? "sidebar"
          : window.innerWidth <= 768
          ? "sidebar"
          : "sidebarClose"
      } ${isSidebarExpanded ? "sidebarMobileExpand" : ""}`}
    >
      {/* <sidebar> */}
      <div className="logo d-none d-md-flex">
        <a href="#">
          <img src="../assets/img/logo.png" alt="Logo" title="Logo" />
        </a>
      </div>
      <div className="menu">
        <h3>General</h3>
        <ul>
          <li className="acc">
            <Link to="/" className="collapsed" onClick={toggleSidebar}>
              <img src={categoryIcon} alt="app category" />
              <span>Dashboard</span>
            </Link>
            <div className="collapse" id="collapseExample1">
              <div className="acc-links"></div>
            </div>
          </li>
            {filteredNavBarLinkLists.map((category, index) => {
            const sortedLinks = category.links.sort((a, b) => {
              const titleA = a.name.toUpperCase();
              const titleB = b.name.toUpperCase();
              if (titleA < titleB) {
                return -1;
              }
              if (titleA > titleB) {
                return 1;
              }
              return 0;
            });
            return (
              <li className="acc" key={index}>
                <a
                  className="collapsed"
                  data-bs-toggle="collapse"
                  href={`#collapseExample${index}`}
                  role="button"
                  aria-expanded="false"
                  aria-controls={`collapseExample${index}`}
                >
                  <img src={categoryIcon} alt="app category" />
                  <span>{category.category}</span>
                  <span className="angle angleDown ms-auto"></span>
                </a>
                <div className="collapse" id={`collapseExample${index}`}>
                  <div className="acc-links">
                    {sortedLinks.map((link, idx) => (
                      <Link
                        onClick={toggleSidebar}
                        style={{ marginBottom: "10px" }}
                        to={link.link}
                        className="acc-link"
                        key={idx}
                      >
                        <span className="sidebar-icon">{link.icon}</span>
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </li>
            );
          })}

          {isSuperFranchise !== 1 &&
            isFranchiseEmployee !== 1 &&
            isSubFranchise !== 1 && (
              <>
                {hasRoleAccess({ link: "/sample-collection" }) &&
                  hasSectionAccess({ name: "Sample Collection" }) && (
                    <li onClick={toggleSidebar}>
                      <Link
                        onClick={() =>
                          (window.location.href = "/sample-collection")
                        }
                        to="/sample-collection"
                        className="acc-link"
                      >
                        <img src={categoryIcon} alt="app category" />
                        <span>Sample Collection</span>
                      </Link>
                    </li>
                  )}

                {hasRoleAccess({ link: "/patient-wise-search-report" }) &&
                  hasSectionAccess({ name: "Result Entry" }) && (
                    <li onClick={toggleSidebar}>
                      <Link
                        onClick={() =>
                          (window.location.href = "/patient-wise-search-report")
                        }
                        to="/patient-wise-search-report"
                        className="acc-link"
                      >
                        <img src={categoryIcon} alt="app category" />
                        <span>Result Entry</span>
                      </Link>
                    </li>
                  )}
              </>
            )}

          {roles?.length > 0 &&
          isSuperFranchise !== 1 &&
          isFranchiseEmployee !== 1 &&
          isSubFranchise !== 1 ? (
            restrictedLinks.includes("/registration") ||
            roles.some((data) => data?.role_name === "SUPER ADMIN") ? (
              <li onClick={toggleSidebar}>
                <Link
                  onClick={() => (window.location.href = "/registration")}
                  to="/registration"
                  className="acc-link"
                >
                  <img src={categoryIcon} alt="app category" />
                  <span>New Registration</span>
                </Link>
              </li>
            ) : null
          ) : (
            <li onClick={toggleSidebar}>
              <Link
                onClick={() => (window.location.href = "/registration")}
                to="/registration"
                className="acc-link"
              >
                <img src={categoryIcon} alt="app category" />
                <span>New Registration</span>
              </Link>
            </li>
          )}
           {roles?.length > 0 &&
            isSuperFranchise !== 1 &&
            isFranchiseEmployee !== 1 &&
            isSubFranchise !== 1 ? (
              restrictedLinks.includes("/alert-management") ||
              roles.some((data) => data?.role_name === "SUPER ADMIN") ? (
                <li onClick={toggleSidebar}>
                  <Link
                    onClick={() => (window.location.href = "/alert-management")}
                    to="/alert-management"
                    className="acc-link"
                  >
                    <img src={categoryIcon} alt="app category" />
                    <span>Alert Management</span>
                  </Link>
                </li>
              ) : null
            ) : (
              <li onClick={toggleSidebar}>
                <Link
                  onClick={() => (window.location.href = "/alert-management")}
                  to="/alert-management"
                  className="acc-link"
                >
                  <img src={categoryIcon} alt="app category" />
                  <span>Alert Management</span>
                </Link>
              </li>
            )}
          {roles?.length > 0 &&
          isSuperFranchise !== 1 &&
          isFranchiseEmployee !== 1 &&
          isSubFranchise !== 1 ? (
            restrictedLinks.includes("/camp-bulk-booking") ||
            roles.some((data) => data?.role_name === "SUPER ADMIN") ? (
              <li onClick={toggleSidebar}>
                <Link
                  onClick={() => (window.location.href = "/camp-bulk-booking")}
                  to="/camp-bulk-booking"
                  className="acc-link"
                >
                  <img src={categoryIcon} alt="app category" />
                  <span>Camp Bulk Booking</span>
                </Link>
              </li>
            ) : null
          ) : (
            <li onClick={toggleSidebar}>
              <Link
                onClick={() => (window.location.href = "/camp-bulk-booking")}
                to="/camp-bulk-booking"
                className="acc-link"
              >
                <img src={categoryIcon} alt="app category" />
                <span>Camp Bulk Booking</span>
              </Link>
            </li>
          )}
          {/* {roles?.length > 0 &&
            isSuperFranchise !== 1 &&
            isFranchiseEmployee !== 1 &&
            isSubFranchise !== 1 ? (
            restrictedLinks.includes("/investigationpackage") ||
              roles.some((data) => data?.role_name === "SUPER ADMIN") ? (
              <li onClick={toggleSidebar}>
                <Link to="/investigationpackage" className="acc-link">
                  <img src={categoryIcon} alt="app category" />
                  <span>Investigation Package</span>
                </Link>
              </li>
            ) : null
          ) : (
            isFranchiseEmployee === 0 &&
            isSuperFranchise === 0 &&
            isSubFranchise === 0 && (
              <li onClick={toggleSidebar}>
                <Link to="/investigationpackage" className="acc-link">
                  <img src={categoryIcon} alt="app category" />
                  <span>Investigation Package</span>
                </Link>
              </li>
            )
          )} */}
        </ul>
      </div>
    </div>
  );
}

export default SideBar;
